// extracted by mini-css-extract-plugin
export default {"icon":"TextAlignIcon_icon__a4pIx"};